"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var checkbox_1 = __importDefault(require("relements/build/esm/input/checkbox"));
var Utils = __importStar(require("@src/containers/BusinessManagerV2/utils"));
var _utils_1 = require("@src/actions/_utils");
var constants_1 = require("../constants");
var BOT_SETTINGS = {
    title: 'Bot Settings',
    inputs: [
        {
            label: 'Enable Human Assistance',
            key: 'enableHumanAssistance',
            className: 'inline-checkbox',
            component: checkbox_1["default"].Item,
            props: function (data, meta, onChange) { return ({
                value: data[constants_1.INPUT_BLOCK_KEYS.HUMAN_ASSISTANCE],
                onChange: function (checked) {
                    return onChange(constants_1.INPUT_BLOCK_KEYS.HUMAN_ASSISTANCE, checked);
                },
            }); },
        },
        {
            label: 'Enable SmallTalk',
            key: 'enableSmallTalk',
            className: 'inline-checkbox',
            component: checkbox_1["default"].Item,
            props: function (data, meta, onChange) { return ({
                value: data[constants_1.INPUT_BLOCK_KEYS.SMALL_TALK],
                onChange: function (checked) {
                    return onChange(constants_1.INPUT_BLOCK_KEYS.SMALL_TALK, checked);
                },
            }); },
        },
        {
            label: 'Live Agent Chat Tool',
            key: 'liveAgentChatTool',
            component: dropdown_1["default"],
            props: function (data, meta, onChange) {
                var liveAgentOptions = meta[constants_1.INPUT_META_KEYS.ALL_CHAT_TOOLS];
                var selectedValue = data[constants_1.INPUT_BLOCK_KEYS.LIVE_AGENT_CHAT_TOOL] ||
                    meta[constants_1.INPUT_META_KEYS.ALL_CHAT_TOOLS][0];
                return {
                    value: selectedValue,
                    onChange: function (option) {
                        return onChange(constants_1.INPUT_BLOCK_KEYS.LIVE_AGENT_CHAT_TOOL, option, false, false, meta);
                    },
                    options: liveAgentOptions,
                    optionKey: 'value',
                    withSearch: true,
                    invisible: meta.isSelfServe,
                };
            },
        },
        {
            label: 'Active Bots',
            key: 'activeBots',
            component: dropdown_1["default"],
            props: function (data, meta, onChange) {
                var isSuperman = _utils_1.isNewPipeline({
                    pipeline_version: data.pipeline_version,
                });
                var isMultiple = !isSuperman;
                var value = isMultiple
                    ? Utils.dropdownMap(data[constants_1.INPUT_BLOCK_KEYS.ACTIVE_BOTS])
                    : data[constants_1.INPUT_BLOCK_KEYS.ACTIVE_BOTS][0];
                return {
                    value: value,
                    options: Utils.dropdownMap(meta[constants_1.INPUT_META_KEYS.ALL_BOTS]),
                    optionKey: 'value',
                    searchKeys: ['value'],
                    withSearch: true,
                    withMultiple: isMultiple,
                    onChange: function (option) {
                        return onChange(constants_1.INPUT_BLOCK_KEYS.ACTIVE_BOTS, isMultiple ? option : [option.value], isMultiple);
                    },
                };
            },
        },
        {
            label: 'Default Bot',
            key: 'defaultBot',
            component: dropdown_1["default"],
            props: function (data, meta, onChange) {
                var activeBots = Utils.dropdownMap(data[constants_1.INPUT_BLOCK_KEYS.ACTIVE_BOTS]);
                var defaultBot = data[constants_1.INPUT_BLOCK_KEYS.ACTIVE_BOTS].includes(data[constants_1.INPUT_BLOCK_KEYS.DEFAULT_BOT]) && data[constants_1.INPUT_BLOCK_KEYS.DEFAULT_BOT];
                return {
                    value: defaultBot,
                    optionKey: 'value',
                    searchKeys: ['value'],
                    withSearch: true,
                    onChange: function (option) {
                        return onChange(constants_1.INPUT_BLOCK_KEYS.DEFAULT_BOT, option.value);
                    },
                    options: activeBots,
                    allowClear: true,
                };
            },
        },
        {
            label: 'Fallback Bot',
            key: 'fallbackBot',
            component: dropdown_1["default"],
            props: function (data, meta, onChange) {
                var activeBots = Utils.dropdownMap(data[constants_1.INPUT_BLOCK_KEYS.ACTIVE_BOTS]);
                var fallbackBot = data[constants_1.INPUT_BLOCK_KEYS.ACTIVE_BOTS].includes(data[constants_1.INPUT_BLOCK_KEYS.FALLBACK_BOT]) && data[constants_1.INPUT_BLOCK_KEYS.FALLBACK_BOT];
                return {
                    value: fallbackBot,
                    optionKey: 'value',
                    searchKeys: ['value'],
                    withSearch: true,
                    onChange: function (option) {
                        return onChange(constants_1.INPUT_BLOCK_KEYS.FALLBACK_BOT, option.value);
                    },
                    options: activeBots,
                    allowClear: true,
                };
            },
        },
    ],
};
exports["default"] = BOT_SETTINGS;
